import { render, staticRenderFns } from "./BaseUploadFile.vue?vue&type=template&id=e16e7114"
import script from "./BaseUploadFile.vue?vue&type=script&lang=js"
export * from "./BaseUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports